import { horizontalRotate, verticalRotate } from '@/views/template-configuration/utils/js/rotate'
import { allUnitArr } from '../../utils/js/enum'
import { recognizeObjective } from '../js/recognise'
import { sortBy } from 'lodash'
import { cloneDeep } from 'lodash/lang'

const objectiveHandle = {
	data() {
		return {
			//手动配置 基本信息
			opeObjForm: {
				rowNum: 5,
				colNum: 4,
				width: 40,
				height: 30
			},
			//手动配置 图片信息
			resizeDragVal: {
				left: 150,
				top: 100,
				width: 0,
				height: 0
			},
			//no use
			isHandleFount: false,
			//
			rectDetailState: false,
			//手动配置 结果  没有flat
			resultObjBoxObjList: {},
			//手动配置 结果
			resultObjBox: [],
			//手动配置 框子的激活状态
			isRecogniseDo: true
		}
	},
	watch: {
		//图片信息
		clipImg: {
			handler(val) {
				const _this = this
				let img = new Image()
				img.src = val
				img.onload = function() {
					_this.resizeDragVal.width = img.width
					_this.resizeDragVal.height = img.height
					_this.resizeDragVal = { top: 100, left: 150, width: _this.resizeDragVal.width, height: _this.resizeDragVal.height }
					_this.generateObjective()
				}
			}
		},
		//图片信息
		tempEditImgInfo(val) {
			this.currentImg = val.list[this.tempCurrentImgIndex.curIndex]
		},
		//当前图片信息
		tempCurrentImgIndex(val) {
			this.currentImg = this.tempEditImgInfo.list[val.curIndex]
		},
		async tempRectObjective(value) {
			let objTopicNames = ''
			if (this.tempObjTopic.length > 0) objTopicNames = this.tempObjTopic.reduce((acc, val) => (acc += val.key), '')
			value.val.forEach(res => {
				if (!res.appendInfo) return false
				res.isActive = false
				res.isPermitDo = false
				res.movieState = false
				res.boxList = JSON.parse(res.appendInfo).box || []
				res.titleList = JSON.parse(res.remarks).title || []
				const remarks = JSON.parse(res.remarks)
				if (Number(remarks.page) === this.currentImgIndex + 1 && objTopicNames === remarks.name) {
					if (JSON.parse(res.remarks)?.align) this.setTempObjDirection(JSON.parse(res.remarks).align)
				}
			})
			this.rectDetail = value.val
			this.rectDetailState = value.state
			this.$forceUpdate()
		}
	},

	methods: {
		activeHandleRect() {
			this.handleActive = !this.handleActive
		},
		// 修改行  列  width height 的值
		rowNumStepVal(val, type) {
			this.opeObjForm[type] = val
			this.generateObjective()
		},
		//手动设置 ------>  生成小框框
		generateObjective() {
			this.handleTitle = []
			let miniWidth = (this.resizeDragVal.width - this.opeObjForm.colNum * this.opeObjForm.width) / (this.opeObjForm.colNum + 1)
			let miniHeight = (this.resizeDragVal.height - this.opeObjForm.rowNum * this.opeObjForm.height) / (this.opeObjForm.rowNum + 1)
			let resultObjBox = []
			let resultObjBoxObjList = {}
			let resaultTopicArr = []
			this.tempObjTopic.forEach(res => resaultTopicArr.push(...sortBy(res.val, ele => Number(ele.smallTopic))))
			let resTopic
			if (this.tempFillDirection == 'H') {
				resTopic = resaultTopicArr.slice(this.initHandleTopic, this.initHandleTopic + this.opeObjForm.rowNum)
				for (let i = 1; i <= this.opeObjForm.rowNum; i++) {
					if (!resultObjBoxObjList[i]) resultObjBoxObjList[i] = []
					for (let j = 1; j <= this.opeObjForm.colNum; j++) {
						const resPos = {
							w: this.opeObjForm.width,
							h: this.opeObjForm.height,
							row: i,
							col: j,
							left: 0,
							top: 0,
							initX: miniWidth * j + this.opeObjForm.width * (j - 1),
							initY: miniHeight * i + this.opeObjForm.height * (i - 1),
							r: 0,
							c: 0,
							m: resTopic[i - 1].bigTopic,
							n: resTopic[i - 1].pkId,
							v: allUnitArr[j - 1],
							i: resTopic[i - 1].smallTopic
						}
						resPos.initX = resPos.x = resPos.left + resPos.initX
						resPos.initY = resPos.y = resPos.top + resPos.initY
						resultObjBox.push(resPos)
						resultObjBoxObjList[i].push(resPos)
					}
				}
			} else if (this.tempFillDirection == 'V') {
				resTopic = resaultTopicArr.slice(this.initHandleTopic, this.initHandleTopic + this.opeObjForm.colNum)
				for (let i = 1; i <= this.opeObjForm.colNum; i++) {
					if (!resultObjBoxObjList[i]) resultObjBoxObjList[i] = []
					for (let j = 1; j <= this.opeObjForm.rowNum; j++) {
						const resPos = {
							w: this.opeObjForm.width,
							h: this.opeObjForm.height,
							row: i,
							col: j,
							left: 0,
							top: 0,
							initX: miniWidth * i + this.opeObjForm.width * (i - 1),
							initY: miniHeight * j + this.opeObjForm.height * (j - 1),
							r: 0,
							c: 0,
							m: resTopic[i - 1].bigTopic,
							n: resTopic[i - 1].pkId,
							v: allUnitArr[j - 1],
							i: resTopic[i - 1].smallTopic
						}
						resPos.initX = resPos.x = resPos.left + resPos.initX
						resPos.initY = resPos.y = resPos.top + resPos.initY
						resultObjBox.push(resPos)
						resultObjBoxObjList[i].push(resPos)
					}
				}
			}

			let resp = cloneDeep(resultObjBoxObjList)
			let stepNum = -1
			for (let key in resp) {
				stepNum += 1
				if (this.tempFillDirection == 'H') {
					this.handleTitle.push(
						Object.assign({}, resp[key][0], {
							x: resp[key][0].x - 50,
							initX: resp[key][0].x - 50,
							v: resTopic[stepNum].smallTopic
						})
					)
				} else {
					this.handleTitle.push(
						Object.assign({}, resp[key][0], {
							y: resp[key][0].y - 50,
							initX: resp[key][0].y - 50,
							v: resTopic[stepNum].smallTopic
						})
					)
				}
			}
			this.resultObjBox = resultObjBox
			this.resultObjBoxObjList = resultObjBoxObjList
			this.referHandleState()
		},
		//缩放
		resizestop(prev, cur) {
			const oldMinWidth = (prev.width - Number(this.opeObjForm.colNum) * Number(Number(this.opeObjForm.width))) / (Number(this.opeObjForm.colNum) + 1)
			const oldMinHeight = (prev.height - Number(this.opeObjForm.rowNum) * Number(Number(this.opeObjForm.height))) / (Number(this.opeObjForm.rowNum) + 1)
			this.resizeDragVal = cur
			this.fixGenerateObj(oldMinWidth, oldMinHeight)
			this.referHandleState()
		},
		// 修改小框框数据
		fixGenerateObj(oldMinWidth, oldMinHeight) {
			this.isRecogniseDo = false
			let miniWidth = (this.resizeDragVal.width - this.opeObjForm.colNum * this.opeObjForm.width) / (this.opeObjForm.colNum + 1)
			let miniHeight = (this.resizeDragVal.height - this.opeObjForm.rowNum * this.opeObjForm.height) / (this.opeObjForm.rowNum + 1)
			const dragVal = cloneDeep(this.resizeDragVal)
			dragVal.left += oldMinWidth - miniWidth
			dragVal.top += oldMinHeight - miniHeight
			this.resultObjBox.forEach(res => {
				res.w = this.opeObjForm.width
				res.h = this.opeObjForm.height
				if (this.tempFillDirection == 'H') {
					res.initX = miniWidth * res.col + this.opeObjForm.width * (res.col - 1)
					res.initY = miniHeight * res.row + this.opeObjForm.height * (res.row - 1)
				} else {
					res.initX = miniWidth * res.row + this.opeObjForm.width * (res.row - 1)
					res.initY = miniHeight * res.col + this.opeObjForm.height * (res.col - 1)
				}
				res.x = res.left + res.initX
				res.y = res.top + res.initY
			})
			this.dragstop(dragVal)
			const _this = this
			setTimeout(() => (_this.isRecogniseDo = true), 300)
		},
		//拖拽
		dragstop(val) {
			this.resizeDragVal = val
		},
		// 返回
		backRecognise() {
			this.$delete(this.rectDetail, this.rectDetail.length - 1)
			this.setTempRectObjective({ val: this.rectDetail, state: this.rectDetailState })
			this.setHandHandleState(false)
		},
		//竖直向下旋转  btn
		verticalClockwiseRotationDown() {
			this.verticalRotate(0.1)
		},
		//竖直向上旋转 btn
		verticalUnClockwiseRotationUp() {
			this.verticalRotate(-0.1)
		},
		// 水平向右旋转 btn
		horizontalClockwiseRotationRight() {
			this.horizontalRotate(0.1)
		},
		// 水平向左旋转 btn
		horizontalClockwiseRotationLeft() {
			this.horizontalRotate(-0.1)
		},
		// 竖直方向上的旋转
		verticalRotate(degree) {
			verticalRotate({ box: Object.values(this.resultObjBoxObjList).flat(Infinity), title: [] }, degree).then(resp => (this.resultBox = resp.box))
			this.referHandleState()
		},
		// 水平方向的旋转
		horizontalRotate(degree) {
			horizontalRotate({ box: Object.values(this.resultObjBoxObjList).flat(Infinity), title: [] }, degree).then(resp => (this.resultBox = resp))
			this.referHandleState()
		},
		referHandleState() {
			const _this = this
			this.isRecogniseDo = false
			setTimeout(() => (_this.isRecogniseDo = true), 300)
		},
		// 保存
		async save() {
			this.startX += this.resizeDragVal.left - 150
			this.startY += this.resizeDragVal.top - 100
			this.endX = this.startX + this.resizeDragVal.width
			this.endY = this.startY + this.resizeDragVal.height
			let horizontalData = [],
				title = []
			// 下面两种情况下做识别
			//1。题号方向水平,填图方向竖直    2。题号方向竖直  填图方向水平
			if ((this.tempFillDirection === 'V' && this.tempObjDirection === 'H') || (this.tempFillDirection === 'H' && this.tempObjDirection === 'V')) {
				horizontalData = recognizeObjective(this, this.resultObjBox, this.handleTitle, null, null, true)
				title = this.handleTitle
			}
			this.addDropRect(this.endX, this.endY, this.startX, this.startY, this.resultObjBox, title, horizontalData)
			this.setHandHandleState(false)
			// 她妈的  在这设置  todo
			if (this.tempFillDirection == 'V') {
				this.initHandleTopic += this.opeObjForm.colNum
			} else {
				this.initHandleTopic += this.opeObjForm.rowNum
			}
		},
		//手动配置  小框框 拖动
		rectDragStopIndex(info) {
			this.resultObjBox[info.index].x = info.pos.left
			this.resultObjBox[info.index].y = info.pos.top
		}
	}
}
export default objectiveHandle
